import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedCareerPathwaysExploreRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const [careerFamilies, featuredRoles] = await Promise.all([
      this.reimaginedData.fetchCareerFamilies(),
      this.reimaginedData.fetchFeaturedRoles(),
    ]);

    return {
      careerFamilies,
      featuredRoles,
    };
  }
}
